import React from "react";
import {
  Button,
  withStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import AddIcon from "@material-ui/icons/Add";
import toastType from "../../../API/CallUtils/tostyNotification";
import SportEvent from "../../../API/SportEvent";
import CircularProgress from "@material-ui/core/CircularProgress";
import SelectDisiplines from "../Selects/Disiplenes";

const styles = (theme) => ({
  paper: {
    width: "100%",
    minHeight: "100px",
    minWidth: "400px",
  },
});

class addCandidateDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = { Select: null, Oncreate: false, SelectedSport: "" };
  }
  componentDidMount = async () => {};
  create = async () => {
    try {
      this.setState({
        Oncreate: true,
      });

      const Deli = await SportEvent.SportEventDisiplineCreate(
        "",
        this.state.SelectedSport,
        this.props.id
      );
      console.log(Deli);
      if (Deli.status === "success") {
        this.setState({
          Oncreate: false,
        });
        toastType.success("Se creado con éxito");
        await this.props.Refresh("CreateDialog");
      } else {
        this.setState({
          Oncreate: false,
        });
        toastType.error("SSE No fue Posible Agregar el deporte");
      }
    } catch (e) {
      this.setState({
        Oncreate: false,
      });
      toastType.error("CSE No fue posible Agregar el deporte");
      console.log(e);
    }
  };
  select = async (value) => {
    this.setState({ SelectedSport: value });
  };

  render() {
    const { classes } = this.props;
    return (
      <Dialog
        open={this.props.DialogOpen}
        onClose={this.props.DialogClose}
        maxWidth="lg"
      >
        <DialogTitle id="form-dialog-title">Agregar deporte </DialogTitle>
        <DialogContent className={classes.paper}>
          <SelectDisiplines Select={this.select} />
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.DialogClose} color="secondary">
            <CloseIcon />
          </Button>
          {this.state.SelectedSport > 0
            ? [
                !this.state.Oncreate ? (
                  <Button color="Primary" onClick={this.create}>
                    <AddIcon />
                  </Button>
                ) : (
                  <Button color="Primary" disabled>
                    <CircularProgress />
                  </Button>
                ),
              ]
            : [
                <Button color="Primary" disabled>
                  <AddIcon />
                </Button>,
              ]}
        </DialogActions>
      </Dialog>
    );
  }
}

export default withStyles(styles)(addCandidateDialog);
